export default __webpack_public_path__ + "static/media/sun_black_01-1.be4cc8e6.jpg";